import { CellContext } from '@tanstack/react-table';
import { ECPLinkRenderer } from '../../../link/ECPLinkRenderer';

export const EcpLinkCellRenderer = <TData, TValue>(props: CellContext<TData, TValue>): JSX.Element => {
  const { getValue, row, column } = props;
  const id = row.getValue('id') as string;
  const value = getValue() as string;

  if (value == null) {
    return <div>{'—'}</div>;
  }

  if (id == null) {
    return <div>{value}</div>;
  }

  return <ECPLinkRenderer id={id} value={value} {...column.columnDef.meta?.cellTypeOptions} />;
};
